export const StatiProfittiSettimanali = {
    PENDING_APPROVE: 'Pending approve',
    PENDING_DISTRIBUTION: 'Pending distribution',
    DISTRIBUTED: 'Distributed'
};